module.exports = __webpack_public_path__ + "img/電気回路_6_1_2.a9a109f9.png";